const helpPhoneNumbers = {
    AppointmentNotFound: {
        VCC: '1-833-402-5803',
        JSA: '1-844-215-2443',
        CAW: '1-833-413-9745',
    },
};

function getDepartmentAbbrFromAppt(appointment) {
    if (appointment.isVCC) {
        return 'VCC';
    } else if (appointment.isJSA) {
        return 'JSA';
    } else if (appointment.isCAW) {
        return 'CAW';
    } else if (appointment.isVPCP) {
        return 'VPCP';
    }
}

function getHelpPhoneNumber(appointment, messageType) {
    const department = getDepartmentAbbrFromAppt(appointment);
    return helpPhoneNumbers[messageType][department];
}

export { getDepartmentAbbrFromAppt, getHelpPhoneNumber };
